import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
import Catalogs from '../catalogs'
const model = (payload) => ({
  // columns
  id: payload.id,
  manual_folio: payload.manual_folio,
  supplier_id: payload.supplier_id,
  currency_id: payload.currency_id,
  exchange_rate: payload.exchange_rate ? payload.exchange_rate : 1,
  branch_id: payload.branch_id
})
var crud = new Crud('PurchaseOrders', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  purchaseOrder: {},
  purchaseOrders: [],
  purchaseOrderDetails: [],
  convertedDetails: [],
  tabSheet: [],
  validProduct: false,
  catalog: {}
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  UPDATE_PURCHASE_ORDER (state, payload) {
    state.purchaseOrder = payload.data
    state.purchaseOrderDetails = payload.data.details
  },
  CONVERT_TO_ARRAY (state, payload) {
    var keys = [
      'code',
      'quantity',
      'price',
      'alternative_code'
    ]
    var i = 0
    var k = 0
    var obj = null
    var output = []

    for (i = 0; i < payload.length; i++) {
      obj = {}

      for (k = 0; k < keys.length; k++) {
        obj[keys[k]] = payload[i][k]
      }
      output.push(obj)
    }
    state.convertedDetails = output
    return state.convertedDetails
  },
  SET_VALID_PRODUCT (state, payload) {
    state.validProduct = payload
  },
  SET_PRODUCTS (state, payload) {
    state.purchaseOrderDetails = []
    state.convertedDetails.forEach(function (element) {
      let product = payload.findIndex(u => u.code === element.code)
      if (product >= 0) {
        let subtotal = parseFloat(element.quantity.replace(/[^0-9.]/g, '')) * parseFloat(element.price.replace(/[^0-9.]/g, ''))
        let data = {
          ...element,
          product_id: payload[product].id,
          subtotal: parseFloat(subtotal).toFixed(2),
          total: parseFloat(subtotal).toFixed(2),
          quantity: parseFloat(element.quantity.replace(/[^0-9.]/g, '')).toFixed(2),
          price: parseFloat(element.price.replace(/[^0-9.]/g, '')).toFixed(2)
        }
        state.purchaseOrderDetails.push(data)
      }
    })
  },
  CLEAN_SPREAD_SHEET (state) {
    state.tabSheet = []
  },
  SET_EDITED_DETAILS (state, payload) {
    state.purchaseOrderDetails = payload.details
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  convertToArrayOfObjects ({ commit }, payload) {
    commit('CONVERT_TO_ARRAY', payload)
  },
  cleanSpreadSheet ({ commit }, payload) {
    commit('CLEAN_SPREAD_SHEET')
  },
  async editPurchaseOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`purchase-orders/${payload.id}/details-with-excel`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EDITED_DETAILS', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPurchaseOrder ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.get(`purchase-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_ORDER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  print ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/purchase-orders/print?id=${payload.id}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async validateProduct ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`products/validate-by-codes`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data[0]) {
          commit('SET_PRODUCTS', response.data[1])
          commit('SET_VALID_PRODUCT', response.data[0])
        } else {
          commit('SET_VALID_PRODUCT', response.data[0])
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'products.not_found_title', text: 'Producto no encontrado: ' + response.data[2] }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async hasNonCancelledShipments ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-order/${payload.id}/has-non-cancelled-shipments`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data) {
          return response.data
        } else {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'purchase_orders.has_active_shipment_error' }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async checkBalanceByOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`purchase-orders/check-balance-by-order`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'Balance actualizado', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  async updateQuantities ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/purchase-order-details/update-quantities-by-id`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'Cantidades Actualizadas', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  sendAlertExcelWithoutProducts ({ commit }, payload) {
    commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.title_without_products', text: 'errors.excel_without_products' }, { root: true })
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  purchaseOrder: state => state.purchaseOrder,
  purchaseOrders: state => state.purchaseOrders,
  purchaseOrderDetails: state => state.purchaseOrderDetails,
  convertedDetails: state => state.convertedDetails,
  tabSheet: state => state.tabSheet,
  validProduct: state => state.validProduct,
  suppliers: state => state.suppliers
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
